import { JSEncrypt } from "jsencrypt";

const win: any = window

export function encrypt(message: any) {
  const publicKey = win.PK;
  const RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  const encryptedMessage = RSAEncrypt.encrypt(message);

  return encryptedMessage;
}

const createTransactionID = (isCorrelationId = false) => {
  const currentDateTime = new Date()
    .toISOString()
    .replace(/-|:|T/gi, '')
    .replace('.', '')
    .slice(2)
    .slice(0, -1)
  return (
    'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}

export { createTransactionID };